import { List, styles } from "./List";
import { Pagination } from "./Pagination";

const ContentList = ({ data = [] }) => {
  return (
    <div style={styles.container}>
      <table style={styles.table}>
        <thead >
          <tr>
            <th style={styles.th}>Board</th>
            <th style={styles.th}>Grade</th>
            <th style={styles.th}>Subject</th>
            <th style={styles.th}>Topic</th>
            <th style={styles.th}>Questions</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>Created At</th>
          </tr>
        </thead>

        <tbody >
            {data.map((item) => {
              const status = item.current_stage === "Instructional Framework Builder"?"completed":"incomplete";

              return <tr style={styles.tr} key={item.id}>
                <td style={styles.td}>{item.board?.name}</td>
                <td style={styles.td}>{item.grade?.name}</td>
                <td style={styles.td}>{item.subject?.name}</td>
                <td style={styles.td}>{item.topic}</td>
                <td style={styles.td}>{item.number_of_questions}</td>
                <td style={styles.td}>
                   <span style={{...styles.status,...styles[status]}}>{status}</span>
                </td>
                <td style={styles.td}>
                  {new Date(item.created_at).toLocaleDateString()}
                </td>
              </tr>
})
          }
        </tbody>
      </table>
    </div>
  );
};

export function WorksheetList({ loading, error, message, list, className = "", pagination, onPageChange }) {
  return (
    <List className={className} loading={loading} error={error} message={message}>
       <ContentList data={list}/>
       {pagination?<Pagination {...pagination} onPageChange={onPageChange}/>:null}
    </List>
  );
}
